import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.4 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      data-testid="scroll-top-button"
      aria-label="Back to top"
      onClick={toTop}
      className={`fixed bottom-6 right-6 z-50 w-12 h-12 rounded-full bg-[#C5A059] text-[#141312] border border-[#E8CD8F]/60 shadow-lg shadow-black/50 flex items-center justify-center hover:bg-[#D9B877] hover:scale-110 transition-all duration-300 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
